import React, { memo } from 'react';

import { ColumnProps } from 'features/tissInvoicing/types/types.common';
import Columns from 'features/tissInvoicing/components/Columns';

export const columns: ColumnProps[] = [
  { name: 'Guia', align: 'left', size: 'medium' },
  { name: 'Data', align: 'left', size: 'medium' },
  { name: 'Paciente', align: 'left', size: 'medium' },
  { name: 'Profissional', align: 'left', size: 'medium' },
  { name: 'Qtde.', align: 'left', size: 'small' },
  { name: 'Valor (R$)', align: 'left', size: 'small' },
];

const AddGuidesColumns = () => <Columns columns={columns} />;

export default memo(AddGuidesColumns);
